import { styled } from "@acko-tech/building-blocks.ui.common";

export const HeadingWrapper = styled.div<{ hideOnDesktop?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  ${(props) =>
    props.hideOnDesktop
      ? `
    @media (min-width: 769px) {
      display: none;
    }
  `
      : ""}
`;

export const MainContainer = styled.div`
  width: 100%;
  color: #040222;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.1px;
  z-index: 1;

  ${(props) => props.styles}
  span {
    color: #7c47e1;
  }
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 28px;
    width: 100%;
    ${(props) => props.mStyles}
`;
